import * as React from 'react';
import Badge from '@mui/joy/Badge';
import Avatar from '@mui/joy/Avatar';

export default function AvatarWithStatus({ online, ...other }) {
  const avatar = <Avatar size="md" color="primary" {...other} />;
  if (typeof online !== 'boolean') return avatar;
  return (
    <Badge color={online ? 'success' : 'neutral'} variant={online ? 'solid' : 'soft'}
      size="sm" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} badgeInset="4px 4px"
      aria-label={online ? 'В сети' : 'Не в сети'}>
      {avatar}
    </Badge>
  );
}